export const fileDict = {
  guaranteeLetter: 'Гарантийное письмо',
  initialPaymentConfirmation: 'Скан чека оплаты ПВ',
  extrajudicialEnforcement: 'Подписанный внесудебный документ',
  marriageContract: 'Подписанный Брачный контракт',
  spouseConsent: 'Согласие супруга/супруги на внесудебную реализацию',
  pledgeAgreementTemplate: 'Шаблон Договора залога',
  pledgeRegistrationTemplate: 'Заявление о регистрации залога',
  pledgeAgreementSigned: 'Подписанный Скан договора',
  pledgeRegistrationSigned: 'Подписанный Скан заявления',
  marriageAbsence: 'Документ об отсутствии брака',
  loanApprovalNoticeEubank: 'Уведомление об одобрении банковского займа',
  paymentOrderEubank: 'Платежное поручение',
  certificateOrigin:
    'Сертификат о происхождении товара/Одобрение типа транспортного средства (ОТТС)'
};

export type fileDictType = keyof typeof fileDict;

export const COLLAPSE_VALID_FILES = [
  'otherDoc',
  'clientPhoto',
  'docPhoto',
  'PaymentOrderHalyk',
  'incomeCert'
];
